/**
 * 配列の中身がnullかどうかをチェックする関数
 */
export const nonNullable = <T>(value: T): value is NonNullable<T> => value !== null;
